(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const ticker = document.querySelector('.js-ticker');
    const wrapper = ticker.querySelector('.wrapper');

    // Clone the wrapper content to create a seamless scroll
    const clone = wrapper.cloneNode(true);
    ticker.appendChild(clone);

    // Calculate and set the correct width for both the original and clone
    const wrapperWidth = wrapper.scrollWidth;
    wrapper.style.width = `${wrapperWidth}px`;
    clone.style.width = `${wrapperWidth}px`;

    // Set the animation duration based on content width
    const animationDuration = wrapperWidth / 50; // Adjust speed factor (higher value = slower)
    wrapper.style.animationDuration = `${animationDuration}s`;
    clone.style.animationDuration = `${animationDuration}s`;

    // Adjust the width of the ticker container
    ticker.style.width = `${wrapperWidth * 2}px`;

    // Re-adjust on window resize for responsiveness
    window.addEventListener('resize', () => {
      const newWrapperWidth = wrapper.scrollWidth;

      // Update width for both wrappers
      wrapper.style.width = `${newWrapperWidth}px`;
      clone.style.width = `${newWrapperWidth}px`;

      // Update animation duration
      const newAnimationDuration = newWrapperWidth / 50;
      wrapper.style.animationDuration = `${newAnimationDuration}s`;
      clone.style.animationDuration = `${newAnimationDuration}s`;

      // Update the ticker's total width
      ticker.style.width = `${newWrapperWidth * 2}px`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee_2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const ticker = document.querySelector('.js-ticker1');
    const wrapper = ticker.querySelector('.wrapper1');

    // Clone the wrapper content to create a seamless scroll
    const clone = wrapper.cloneNode(true);
    ticker.appendChild(clone);

    // Calculate and set the correct width for both the original and clone
    const wrapperWidth = wrapper.scrollWidth;
    wrapper.style.width = `${wrapperWidth}px`;
    clone.style.width = `${wrapperWidth}px`;

    // Set the animation duration based on content width
    const animationDuration = wrapperWidth / 50; // Adjust speed factor (higher value = slower)
    wrapper.style.animationDuration = `${animationDuration}s`;
    clone.style.animationDuration = `${animationDuration}s`;

    // Adjust the width of the ticker container
    ticker.style.width = `${wrapperWidth * 2}px`;

    // Re-adjust on window resize for responsiveness
    window.addEventListener('resize', () => {
      const newWrapperWidth = wrapper.scrollWidth;

      // Update width for both wrappers
      wrapper.style.width = `${newWrapperWidth}px`;
      clone.style.width = `${newWrapperWidth}px`;

      // Update animation duration
      const newAnimationDuration = newWrapperWidth / 50;
      wrapper.style.animationDuration = `${newAnimationDuration}s`;
      clone.style.animationDuration = `${newAnimationDuration}s`;

      // Update the ticker's total width
      ticker.style.width = `${newWrapperWidth * 2}px`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preloader"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', function() {
  const preloader = document.getElementById('preloader');
  const preloaderSvg = document.getElementById('preloader-svg');
  const content = document.getElementsByClassName('gradient');

  // Preloader dips into black and fades out faster
  gsap.to(preloader, {
    duration: 0.8,  // Reduced duration for quicker transition to black
    backgroundColor: '#ff8b6b',
    ease: "power2.inOut",
    onStart: function() {
      preloaderSvg.style.display = 'none';  // Hide the SVG when the animation starts
    },
    onComplete: function() {
      // Fade out preloader faster
      gsap.to(preloader, {
        duration: 0.5,  // Reduced duration for quicker fade out
        opacity: 0,
        onComplete: function() {
          preloader.style.display = 'none';  // Remove the preloader from the view

          // Fade in content (if needed)
          for (let i = 0; i < content.length; i++) {
            gsap.to(content[i], {
              duration: 0.5,  // Reduced duration for quicker content fade-in
              opacity: 1,
              ease: "power2.inOut"
            });
          }
        }
      });
    }
  });
});



  } catch(e) { console.error(e); }
})();
})();
